var map = {
	"./bandarban.jpg": 782,
	"./bbq.jpg": 661,
	"./default.jpg": 918,
	"./error.jpg": 25,
	"./fetch.png": 335,
	"./group.jpg": 116,
	"./hiking.jpg": 470,
	"./hill.png": 242,
	"./leaf.png": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;